<template>
  <div>
    <br/>
    <section class="hero is-primary">
      <div class="hero-body">
        <div class="container">
          <nav class="breadcrumb is-small" aria-label="breadcrumbs">
            <ul>
              <li><router-link to="/">首頁</router-link></li>
              <li><router-link to="/events" aria-current="page">活動新聞</router-link></li>
              <li class="is-active"><a href="#" aria-current="page">{{ $prismic.richTextAsPlain(post.data.post_title) }}</a></li>
            </ul>
          </nav>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <div class="content">

          <div class="columns is-variable is-1-mobile is-8-desktop">
            <div class="column is-two-thirds">
              <!-- <prismic-edit-button :documentId="documentId"/> -->
              <prismic-rich-text class="is-size-6" :field="post.data.post_title"/>

              <div class="has-text-grey-light">
                <b-icon pack="fas" icon="calendar-alt" size="is-small"></b-icon><span> {{ formatDate(post.data.event_date, true) }}</span>&nbsp;&nbsp;&nbsp;
                <b-icon pack="fas" icon="user" size="is-small"></b-icon><span> Admin</span>
              </div>
              <br/>

              <prismic-rich-text :field="post.data.post_content"/>

              <template v-if="post.data.image_gallery[0].image.url">
                <hr/>
                <div class="subtitle is-size-5">照片集錦</div>
                <div
                  v-for="(image, index) in post.data.image_gallery"
                  :key="'image-' + index"
                  @click="openModal(image)"
                >
                  <prismic-image :field="image.image"/>
                  <prismic-rich-text :field="image.caption"/>
                  <br/>
                </div>
              </template>

              <hr/>
              <div class="level">
                <div class="level-left">
                  <div class="level-item">
                    <router-link class="button is-dark is-outlined" to="/events">
                      <b-icon pack="fas" icon="arrow-left" size="is-small"></b-icon>
                      <span>回到活動新聞</span>
                    </router-link>
                  </div>
                </div>
                <div class="level-right">
                  <div class="level-item">
                    <p class="has-text-grey-light">Last edited: {{ formatDate(post.last_publication_date) }}</p>
                  </div>

                </div>
              </div>

            </div>
            <div class="column">
              <AnnouncementCard/>
            </div>
          </div>


        </div>
      </div>
    </section>
    <b-modal
      :active.sync="modalState"
      :onCancel="() => this.modalState = false"
    >
      <p class="image">
        <img v-bind:src="modalUrl">
      </p>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment';
import AnnouncementCard from '@/components/AnnouncementCard.vue';

export default {
  name: 'post',
  components: {
    AnnouncementCard,
  },
  data() {
    return {
      post: '',
      documentId: '',
      modalState: false,
      modalUrl: '',
    };
  },
  methods: {
    getContent(uid) {
      this.$prismic.client.getByUID('posts', uid).then((document) => {
        if (document) {
          this.documentId = document.id;
          this.post = document;
        } else {
          this.$router.push({ name: 'not-found' });
        }
      });
    },
    formatDate(date, only) {
      if (only) {
        return moment(date).format('h:mm a - MMM D, YYYY').substring(11);
      }
      return moment(date).format('h:mm a - MMM D, YYYY');
    },
    openModal(image) {
      this.modalUrl = image.image.url;
      this.modalState = true;
    },
  },
  created() {
    this.getContent(this.$route.params.uid);
  },
  beforeRouteUpdate(to, from, next) {
    this.getContent(to.params.uid);
    next();
  },
};
</script>

<style lang="scss" scoped>
.hero-body {
  padding: 0.17rem 1.5rem;
}

.content {
  word-break: break-word;
}
</style>
